export default __webpack_public_path__ + "static/media/step4.f6ecfd67.svg";